<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="structure-next"><span><img alt="IllustrationContent-34.png" class="frame" src="OEBPS/image/IllustrationContent-34_fmt.png"/></span> </p>
<div class="calibre1" id="calibre_pb_6"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NGJobHacks_split_006.vue?1d0977e1